const RTL_LANGUAGES = new Set(['ar', 'fa']);

export const applyDocumentDirection = (languageCode) => {
  if (typeof document === 'undefined') return;
  const dir = RTL_LANGUAGES.has(languageCode) ? 'rtl' : 'ltr';
  const html = document.documentElement;
  if (html.getAttribute('dir') !== dir) {
    html.setAttribute('dir', dir);
  }
  if (languageCode && html.getAttribute('lang') !== languageCode) {
    html.setAttribute('lang', languageCode);
  }
};
